import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonIcon, IonInput } from '@ionic/angular/standalone';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { IMAGE_SRC, VALIDATION_MESSAGE } from '../../../shared-constants';

@Component({
  selector: 'app-form-time-picker',
  imports: [
    IonInput,
    NgxMaterialTimepickerModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    IonIcon,
    NgClass,
  ],
  templateUrl: './form-time-picker.component.html',
  styleUrls: ['./form-time-picker.component.scss'],
})
export class FormTimePickerComponent {
  @Input() headerText!: string;
  @Input() form!: FormGroup;
  @Input() control!: string;
  @Input() icon = IMAGE_SRC.CLOCK;
  @Input() defaultStartTime = '00:00';
  @Input() required = true;
  @Input() altIconSpacing = false;
  @Input() placeholderText = this.defaultStartTime;
  @Output() inputChangedEvent = new EventEmitter();

  readonly CONSTS = IMAGE_SRC;
  readonly ERROR_CONSTANTS = VALIDATION_MESSAGE;

  inputChanged($event: string) {
    this.form.get(this.control)?.setValue($event);
    this.form.get(this.control)?.markAsTouched();
    this.form.get(this.control)?.markAsDirty();
    this.inputChangedEvent.emit($event);
  }
}
